module.exports = __webpack_public_path__ + "static/jake-6005dc06e9d4bede88f4b6d388f47eda.jpg";